module.exports = __webpack_public_path__ + "static/img/quick@2x.ece668f2.png";